//Note: replaced $log.error by console.error
/**
 * @ngdoc service
 * @name proximus.core.service:HalService
 * @description
 * # HalService
 * Contains methods to browse hal resource including url, rels, etc.
 */
export default class HalService {
    constructor(entityIdentifier) {
        this.entityIdentifier = entityIdentifier;
    }
    /**
     * retrieves rel url from parent resource
     * @memberof proximus.core.service:HalService
     * @param {Entity} parentEntity
     * @param {EntityC} child entity
     * @returns {String} url
     */
    getEntityUrlFromParentEntity(parentEntity, entity) {
        let url;
        try {
            if (parentEntity.value._embedded) {
                if (Array.isArray(parentEntity.value._embedded[entity.rel])) {
                    url = parentEntity.value._links[entity.rel].href;
                }
                else {
                    if (entity.parentRelUrlPath) {
                        let embedded = parentEntity.value._embedded;
                        if (Array.isArray(entity.parentRelUrlPath)) {
                            entity.parentRelUrlPath.forEach(rel => {
                                embedded = embedded[rel];
                            });
                        }
                        url = embedded._links[entity.rel].href;
                    }
                    else {
                        url = parentEntity.value._embedded[entity.rel]._links.self.href;
                    }
                }
            }
            else {
                if (parentEntity.value['_links']) {
                    url = parentEntity.value['_links'][entity.rel].href;
                }
            }
        }
        catch (error) {
            console.error({
                message: 'Cannot fetch URL from parentRel',
                context: {
                    module: 'proximus.core',
                    service: 'hal service',
                    parentEntity: parentEntity.rel,
                    entity: entity.rel,
                },
            });
        }
        return this.entityIdentifier.replaceUrlPlaceholders(url, entity.parameters);
    }
}
